<template>
  <div class="container">
    <template v-if="loading">
      <Spin fix>
      <BaseLoading style="margin:0;margin-bottom:10px;height:20px" />
      加载中
    </Spin>
    </template>
    <template  v-else>
      <div class="flex-wrap flex-between flow-header" style="height:70px;border-bottom:1px solid var(--border);">
      <div class="flex-wrap">
      <div class="icon-wrap">
      <BaseIcon :icon="flow.icon || 'lianjieliu'" :size="30" />
      </div>
      <div>
        <div class="title">{{flow.name}} <BaseVersion :value="flow.version" /></div>
        <div class="sub">{{flow.description}}</div>
      </div>
      </div>
      <div class="flex-wrap split10">

      </div>
    </div>
      <div class="flex-wrap flex-between" style="align-items:stretch;height:calc(100% - 140px);">
        <div style="flex-grow:1;">
    <div style="overflow-y:auto;padding:5px;background:var(--border);border:1px solid var(--border);height:calc(100%);position:relative;">

    <UgoForm
      ref="form"
      :key="'start-' + (form && form.id) + '-' + aclRenderKey"
      :form="form"
      :acl="acl"
      style="background:none;height:100%;margin:0 auto;"
      v-model="formData"
      @input="onFormInput"
    />
  </div>

        </div>
        <div style="margin-left:10px;position:relative;width:400px;border-left:1px solid var(--border);padding-left:10px;flex-shrink:0;height:100%;position:relative;">
          <BaseBoardSubTitle name="流程图"></BaseBoardSubTitle>
          <FlowGraph style="width:100%;height:200px;position:relative;" :data="graphData" />

          <BaseBoardSubTitle name="流程配置"></BaseBoardSubTitle>
          <div style="overflow-y:auto;height:calc(100% - 270px);background:var(--bg3);border-radius:5px;border:1px solid var(--border);padding:15px;"  v-if="version && version.nodes">
          <Steps :current="0" direction="vertical">
          <template v-for="(l, li) in nodes">
            <Step :key="'lv-' + li">
              <div  slot="content">
            <template v-for="n in l">
              <NodeCreate
                v-if="needsNodeConfig(n)"
                :key="n.id"
                :value="nodeData[n.id]"
                :node="n"
                :db="formData"
                :readonly="isCloneFollower(n)"
                @input="onNodeConfigInput(n.id, $event)"
              />
            </template>
          </div>
          </Step>

          </template>
        </Steps>
      </div>
        </div>


      </div>
      <div class="flex-wrap flex-right" style="height:70px;border-top:1px solid var(--border);">
    <Button long type="primary" size="large" style="width:200px" @click="handleSubmit">提交</Button>
    <Button long size="large" style="width:120px;margin-left:20px;" @click="handleSaveAsDraft">保存草稿</Button>
    <Button long size="large" style="width:120px;margin-left:20px;" @click="$emit('event', {type: 'open-drafts'})">草稿箱</Button>
     <Button long size="large" style="width:120px;margin-left:20px;" @click="handleCancel">取消</Button>
    </div>
  </template>

  </div>
</template>

<script>
import UgoForm from '../form/index';
import FlowGraph from './graph.vue';

import NodeCreate from '@/components/flow/node/create';
import {syncCloneExecutorsAcrossNodes, syncAllSharedCloneGroups, isCloneShareFollower} from '@/components/flow/clone-executor-sync';
import {unpackAclMap, prepareFormForAcl} from '@/components/flow/flow-acl';
import {versionFromFlow, buildConfigNodeLevels} from '@/components/flow/flow-version';
import FlowLocalRuntime from '@/components/flow/runtime/FlowLocalRuntime';
import mixinPageState from '@/mixins/page_state';
import {resolveNameTemplate, buildTimestampRandomName} from '@/components/flow/flow-name-rule';
export default {
  data() {
    return {
      loading: false,
      syncingCloneExecutors: false,
      flowData: {
        form: {},
      },
      formData: {},
      nodeData: {},
      form: {},
      acl: {},
      graphData: {},
      instData: {},
      pageStateFields: ['formData', 'nodeData', 'manualName', 'nameManuallyEdited', 'fallbackName'],
      manualName: '',
      nameManuallyEdited: false,
      /** 无规则/规则结果为空时的默认名：时间戳+3位随机数 */
      fallbackName: buildTimestampRandomName(),
      /** 当前加载的草稿 id（再次保存时更新） */
      currentDraftId: null,
    };
  },
  mixins: [mixinPageState],
  watch: {
    flow: {
      handler(v) {
        this.getStartView();
      },
      immediate: true,
      deep: true,
    },
    displayInstanceName() {
      this.emitTitleChange();
    },
    nameRule() {
      // 规则变化时，若未手改则回到自动
      if (!this.nameManuallyEdited) this.emitTitleChange();
    },
  },
  components: {UgoForm, FlowGraph, NodeCreate},
  mounted() {
    this.emitTitleChange();
  },
  computed: {
    version() {
      return versionFromFlow(this.flow);
    },
    nameRule() {
      const opt = (this.version && this.version.option) || {};
      return String(opt.nameRule || '').trim();
    },
    /** 按命名规则从当前表单实时生成 */
    autoName() {
      if (!this.nameRule) return '';
      return resolveNameTemplate(this.nameRule, this.formData);
    },
    displayInstanceName() {
      if (this.nameManuallyEdited) {
        return String(this.manualName || '').trim() || this.fallbackName;
      }
      if (this.autoName) return this.autoName;
      return this.fallbackName || buildTimestampRandomName();
    },
    /** 提交给后端的最终名称：手改 > 规则 > 时间戳随机兜底 */
    resolvedSubmitName() {
      if (this.nameManuallyEdited) {
        return String(this.manualName || '').trim() || this.fallbackName;
      }
      return String(this.autoName || '').trim() || this.fallbackName;
    },
    nodes() {
      return buildConfigNodeLevels(this.version.nodes, this.version.actions);
    },
    flatConfigNodes() {
      return this.nodes.flat();
    },
    aclRenderKey() {
      const a = this.acl || {};
      try {
        return JSON.stringify(a);
      } catch (e) {
        return String(Object.keys(a).length);
      }
    },
  },
  props: {
    'flow': {
      type: Object,
      default: ()=>({}),
    },
    'data':{
      type: Object,
      default: ()=>({}),
    }
  },
  methods: {
    emitTitleChange() {
      this.$emit('title-change', {
        name: this.displayInstanceName,
        autoName: this.autoName,
        submitName: this.resolvedSubmitName,
        manual: this.nameManuallyEdited,
      });
    },
    /** 供 AppBar 调用：开始手改（返回当前展示名） */
    beginManualNameEdit() {
      return this.displayInstanceName;
    },
    /** 供 AppBar 调用：确认手改；空或与规则名相同则恢复自动 */
    applyManualName(name) {
      const next = String(name == null ? '' : name).trim();
      if (!next || next === this.autoName || next === this.fallbackName) {
        this.nameManuallyEdited = false;
        this.manualName = '';
      } else {
        this.nameManuallyEdited = true;
        this.manualName = next;
      }
      this.emitTitleChange();
      return this.displayInstanceName;
    },
    startEditName() {
      return this.beginManualNameEdit();
    },
    confirmEditName(name) {
      return this.applyManualName(name != null ? name : this.manualName);
    },
    /** 草稿快照（不强制校验，允许不完整） */
    getDraftSnapshot() {
      return {
        formData: this.formData && typeof this.formData === 'object'
          ? JSON.parse(JSON.stringify(this.formData))
          : {},
        nodeData: this.nodeData && typeof this.nodeData === 'object'
          ? JSON.parse(JSON.stringify(this.nodeData))
          : {},
        name: this.resolvedSubmitName,
        manualName: this.manualName,
        nameManuallyEdited: this.nameManuallyEdited,
        fallbackName: this.fallbackName,
        flow_version_id: this.version && this.version.id,
      };
    },
    /** 从草稿还原表单与配置 */
    applyDraftPayload(draft) {
      const raw = (draft && (draft.data || draft)) || {};
      const formData = raw.formData && typeof raw.formData === 'object' ? raw.formData : {};
      const nodeData = raw.nodeData && typeof raw.nodeData === 'object' ? raw.nodeData : {};
      this.formData = JSON.parse(JSON.stringify(formData));
      this.nodeData = syncAllSharedCloneGroups(
        JSON.parse(JSON.stringify(nodeData)),
        this.flatConfigNodes,
      );
      if (raw.nameManuallyEdited) {
        this.nameManuallyEdited = true;
        this.manualName = String(raw.manualName || raw.name || '').trim();
      } else {
        this.nameManuallyEdited = false;
        this.manualName = '';
      }
      if (raw.fallbackName) {
        this.fallbackName = String(raw.fallbackName);
      }
      this.currentDraftId = draft && draft.id ? draft.id : null;
      this.queueSharedCloneSync();
      this.emitTitleChange();
      return this.currentDraftId;
    },
    clearDraftBinding() {
      this.currentDraftId = null;
    },
    onNodeConfigInput(nodeId, val) {
      if (this.syncingCloneExecutors) {
        this.$set(this.nodeData, nodeId, val);
        return;
      }
      this.syncingCloneExecutors = true;
      try {
        const next = syncCloneExecutorsAcrossNodes(
          this.nodeData,
          this.flatConfigNodes,
          nodeId,
          val,
        );
        this.nodeData = syncAllSharedCloneGroups(next, this.flatConfigNodes);
      } finally {
        this.$nextTick(() => {
          this.syncingCloneExecutors = false;
        });
      }
    },
    onFormInput(v) {
      const next = v && typeof v === 'object' ? {...v} : {};
      this.formData = next;
      // 克隆同步只走签名变化；这里仅刷新标题（不 deep watch 整表）
      this.emitTitleChange();
    },
    queueSharedCloneSync() {
      this.$nextTick(() => {
        if (this.syncingCloneExecutors) return;
        const next = syncAllSharedCloneGroups(this.nodeData, this.flatConfigNodes);
        if (next !== this.nodeData) {
          this.nodeData = next;
        }
      });
    },
    isCloneFollower(node) {
      return isCloneShareFollower(this.flatConfigNodes, node);
    },
    ParseFlow(flow) {
      if (!flow || !Array.isArray(flow.nodes)) {
        return {nodes: [], edges: []};
      }
      return FlowLocalRuntime.normalizeGraph(flow);
    },
    getStartView() {
      this.acl = {};
      this.form = {};
      if (!this.version || !Array.isArray(this.version.nodes)) {
        this.graphData = {nodes: [], edges: []};
        return;
      }
      const node = this.version.nodes.find((n)=>
        n?.graph?.type=='start_node' || n?.type=='start_node');
      if (node?.option?.view_id) {
        this.acl = unpackAclMap(node.option.acl);
        this.getForm(node.option.view_id);
      }
      this.graphData = this.ParseFlow(this.version);
    },
    getForm(id) {
      if (!id) {
        this.form = {};
        return;
      }
      this.$api.get(`forms/${id}`).then((res)=>{
        const form = res.data.data || {};
        prepareFormForAcl(form, this.acl || {});
        this.form = {...form, fields: [...(form.fields || [])]};
        if (this.data) {
          this.formData = Object.assign({}, this.formData, this.data);
        }
      });
    },
    nodeLabel(node) {
      return node.option?.name || node.graph?.text?.value || node.id;
    },
    getClonedByValues(node) {
      const clonedBy = node.option?.clonedBy;
      if (!clonedBy) {
        return null;
      }
      const path = typeof clonedBy === 'string' ? clonedBy : (clonedBy.key || '');
      if (!path) {
        return null;
      }
      const paths = path.split('.');
      let value = this.formData;
      for (let i = 0; i < paths.length; i++) {
        if (value == null) {
          return null;
        }
        value = value[paths[i]];
      }
      return value;
    },
    getClonedByLabel(node) {
      const clonedBy = node.option?.clonedBy;
      if (!clonedBy) {
        return node.option?.cloneBy || '';
      }
      if (typeof clonedBy === 'string') {
        return clonedBy;
      }
      return clonedBy.control?.name || clonedBy.key || node.option?.cloneBy || '';
    },
    hasExecutors(node = {}) {
      if (Array.isArray(node.executors)) {
        return node.executors.length > 0;
      }
      return !!node.executors;
    },
    needsNodeConfig(node) {
      return node.graph?.type !== 'finish_node';
    },
    validateForm() {
      if (!this.$refs.form) {
        this.Error('表单未加载完成，请稍后重试');
        return null;
      }
      const formData = this.$refs.form.submit();
      if (!formData) {
        this.Error('表单未填写完整，请检查必填项');
        return null;
      }
      return formData;
    },
    validateNodeConfig() {
      const flatNodes = this.nodes.flat().filter((node)=>this.needsNodeConfig(node));
      if (flatNodes.length === 0) {
        this.Error('流程配置未加载，请稍后重试');
        return false;
      }
      for (const node of flatNodes) {
        const label = this.nodeLabel(node);
        const nodeVal = this.nodeData[node.id];
        if (node.option?.clonedBy) {
          const relatedValues = this.getClonedByValues(node);
          const fieldLabel = this.getClonedByLabel(node);
          if (!Array.isArray(relatedValues) || relatedValues.length === 0) {
            this.Error(`流程配置不完整：节点「${label}」需先填写关联字段「${fieldLabel}」`);
            return false;
          }
          const cloned = nodeVal?.cloned || {};
          for (const item of relatedValues) {
            let keyPart = item;
            if (item != null && typeof item === 'object') {
              keyPart = item.id != null ? item.id :
                (item.key != null ? item.key : JSON.stringify(item));
            }
            const key = `${node.id}_${keyPart}`;
            const itemLabel = (item != null && typeof item === 'object') ?
              (item.name || item.label || item.title || keyPart) :
              item;
            if (!this.hasExecutors(cloned[key])) {
              const who = node.graph?.type === 'carbon_node' ? '抄送人' : '负责人';
              this.Error(`流程配置不完整：节点「${label}」的「${itemLabel}」未选择${who}`);
              return false;
            }
          }
          continue;
        }
        if (!this.hasExecutors(nodeVal)) {
          const who = node.graph?.type === 'carbon_node' ? '抄送人' : '负责人';
          this.Error(`流程配置不完整：节点「${label}」未选择${who}`);
          return false;
        }
      }
      return true;
    },
    validateBeforeAction() {
      this.nodeData = syncAllSharedCloneGroups(this.nodeData, this.flatConfigNodes);
      const formData = this.validateForm();
      if (!formData) {
        return null;
      }
      if (!this.validateNodeConfig()) {
        return null;
      }
      return formData;
    },
    buildPayload(formData, {draft = false} = {}) {
      const name = this.resolvedSubmitName;
      return {
        flow_version_id: this.version.id,
        formData,
        nodeData: this.nodeData,
        ...(name ? {name} : {}),
        ...(draft ? {draft: true} : {}),
      };
    },
    submit() {
      this.handleSubmit();
    },
    handleSubmit() {
      const formData = this.validateBeforeAction();
      if (!formData) {
        return;
      }
      this.$emit('event', {
        type: 'submit',
        value: {
          ...this.buildPayload(formData),
          draft_id: this.currentDraftId,
        },
      });
    },
    handleCancel() {
      this.$emit('cancel');
    },
    handleSaveAsDraft() {
      // 草稿允许不完整，直接存当前表单与配置快照
      const snap = this.getDraftSnapshot();
      this.$emit('event', {
        type: 'draft',
        value: {
          ...snap,
          draft_id: this.currentDraftId,
        },
      });
    },
  },
};
</script>
<style lang="less">
.flow-header{
  padding:10px;
  background:var(--bg2);
  color:var(--text2);
  .icon-wrap{
    width:50px;
    height:50px;
    display: flex;
    align-items: center;
    justify-content: center;
    background:var(--primary);
    color:var(--hover-text);
    border-radius: 10px;
    flex-shrink: 0;
    margin-right: 10px;
  }
  .title{
    font-size:16px;
  }
  .sub{
    font-size:12px;
    color:var(--subtext2);
  }
}
</style>
